// import { axios_helper_no_header } from "../../axios/AxiosHelper";
import axios from "axios";
import { AuthHeaderStorageKey } from "../../../common_nextgen/hooks/AuthContext";
import getBackendUrl from "../../../environment/BackendService";
/**
 * @todo change to hook
 * 
 * @param {*} data 
 * @returns {Promise<{label: string, value: string}[]>}
 */
export const fetchDropdownValues = async (data) => {  
    try {
        console.log("Calling dropdown",sessionStorage.getItem(AuthHeaderStorageKey))
        const response = await axios.post(`${getBackendUrl()}api/dropdown-options`, data, {
          headers: JSON.parse(sessionStorage.getItem(AuthHeaderStorageKey))
        });
        // const response = await axios_helper_no_header('POST', `api/dropdown-options`, data, null);
        return response.data;
    } catch (error) {  
        console.error("Error fetching dropdown values:", error);  
    }  
  };